import { FC } from 'react'
import { CutterContext, useCutterContext } from './contexts/CutterContext'
import { Channels } from './channels/Channels'
import { InternalContextProvider } from './contexts/InternalContext'
import { Controls } from './controls/Controls'
import { Timeline } from './timeline/Timeline'
import { Toolbar } from './toolbar/Toolbar'
import { Actions } from './actions/Actions'
import './Cutter.scss'
import { Header } from '../components/header/Header'
import { Scroll } from './scroll/Scroll'

interface Props {
  audioBuffer: AudioBuffer
  filename: string
}

export const Cutter: FC<Props> = ({ audioBuffer, filename }) => {
  return (
    <CutterContext.Provider value={useCutterContext(audioBuffer, filename)}>
      <InternalContextProvider>
        <div className="Cutter">
          <Header />
          <Toolbar />
          <Timeline />
          <Channels />
          <Actions />
          <Scroll />
          <Controls />
        </div>
      </InternalContextProvider>
    </CutterContext.Provider>
  )
}
